import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Euro = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.29 55.82">
  <G fill={color}>
    <Path d="M0,21.28h2.18v-7.56c0-4.42,1.04-7.81,3.12-10.17C7.38,1.18,10.52,0,14.73,0s7.36,1.18,9.43,3.55c2.08,2.37,3.12,5.76,3.12,10.17v3.98h-8.11v-4.52c0-1.97-.37-3.36-1.09-4.17-.73-.8-1.77-1.21-3.12-1.21s-2.39.4-3.12,1.21c-.73.81-1.09,2.2-1.09,4.17v8.11h12.01v4.29h-12.01v4.29h12.01v4.29h-12.01v8.5c0,1.98.36,3.35,1.09,4.13.73.78,1.77,1.17,3.12,1.17s2.39-.39,3.12-1.17c.73-.78,1.09-2.16,1.09-4.13v-4.91h8.11v4.37c0,4.42-1.04,7.81-3.12,10.17-2.08,2.37-5.22,3.55-9.43,3.55s-7.35-1.18-9.43-3.55c-2.08-2.36-3.12-5.75-3.12-10.17v-7.95H0v-4.29h2.18v-4.29H0v-4.29Z"/>
  </G>
</Svg>
);
};

export default Euro;
